import React, {useState} from 'react';
import { Select } from 'antd';
import Header from './Header';
import TopRight from './TopRight';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import configData from "./config.json";
var CryptoJS = require("crypto-js");

function Profile() {
  if(!Cookies.get('user')) {
    window.location.href='/';
  }
  const [values, setValues] = useState({ name: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).name, email: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email, company: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).company });



  
  const [errors, setErrors] = useState({ name: "", email: "", company: "" });
  const [editMode, setEditMode] = useState(false);
  // eslint-disable-next-line
  const [updateStart, setUpdateStart] = useState(false);
  // eslint-disable-next-line
  const [apiSuccessStatus, setApiSuccessStatus] = useState(false);
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

  const handleEdit = () => {
    setEditMode(true);
  }

  const handleChangeGoogleId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.google_id = '';
    if(value) {
      setValues((values) => ({ ...values, google_id: value, }));
    }else {
      errors.google_id = 'gogole id is required.';
    }
  };

  const handleChangeAniviewId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.aniview_id = '';
    if(value) {
      setValues((values) => ({ ...values, aniview_id: value, }));
    }else {
      errors.aniview_id = 'aniview id is required';
    }
  };

  const handleChangeAdkernelId = (value) => {
    document.getElementById('partnerError').style.display='none';
    errors.adkernel_id = '';
    if(value) {
      setValues((values) => ({ ...values, adkernel_id: value, }));
    }else {
      errors.adkernel_id = 'adkernal id si required';
    }
  };

  const handleUpdate = () => {
    document.getElementById('partnerError').style.display='none';
    setUpdateStart(true);
  
    const errors = {};
    // setUpdateStart(true);
    if (values.name === '') {
      errors.name = "Please enter your Full Name.";
      // setUpdateStart(false);
    }
    if (!isEmail(values.email)) {
      errors.email = "Please enter valid Email Address.";
      // setUpdateStart(false);
    }
    if (values.company === '') {
      errors.company = "Please enter Company Name.";
      // setUpdateStart(false);
    }
    // if( (values.google_id.length < 1) && (values.aniview_id.length < 1) && (values.adkernel_id.length < 1) ) {
    //   errors.partner_id = "Any one partner ID is needed";
    //   document.getElementById('partnerError').style.display='block';
    //   // setUpdateStart(false);
    // }

    setErrors(errors);
    setEditMode(true);

    if (!Object.keys(errors).length) {
      // setTimeout(function(){
      //   setApiSuccessMessage('Updated Successfully');
      //   setUpdateStart(false);
      //   setEditMode(false);
      // }, 3000);
      // setTimeout(function(){
      //   setApiSuccessMessage('');
      // }, 4000);

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values, null, 2),
      };
      try {
        fetch(configData.SERVER_URL+"/updateUser", requestOptions)
          .then(response => {
            return response.json()
          })
          .then(results => {
            if (results.success === true) {
              setApiSuccessMessage(results.message);
              setUpdateStart(false);
              setEditMode(false);
              Cookies.set('user', CryptoJS.AES.encrypt(JSON.stringify({"user_type": JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).user_type,"name": values.name,"email": JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).email,"company": values.company, google_id: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id, aniview_id: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id, adkernel_id: JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id}), 'XJ3ou%#1').toString(), { expires: 7 });

              setTimeout(function(){
                setApiSuccessMessage('');
              }, 4000);
            } else {
              setApiSuccessMessage(results.message);
              setUpdateStart(false);
              setEditMode(false);
              setTimeout(function(){
                setApiSuccessMessage('');
              }, 4000);
            }
          }).catch(error=>{
            // alert("There is some error in processing your request. Please try again in some time.");
            toast.error("There is some error in processing your request. Please try again in some time.");
            setUpdateStart(false);
          })
        return true;
      } catch (error) {
        // console.log(`Error! ${error.message}`);
        setApiSuccessStatus(false);
        setApiSuccessMessage('Something went wrong. Please Try Again.');
        setUpdateStart(false);
        return false;
      }
    }

    
  }

  // const myData = [
  //   { id: '0', name: 'AAA' },
  //   { id: '1', name: 'BBB' },
  //   { id: '2', name: 'CCC' }
  // ]

  
  // let selectList = [];
  // myData.forEach( data => {
  //     selectList.push(<Select.Option value={data.id} key={data.name}>{data.name}</Select.Option>);
  // } );


  if(Cookies.get('status')) {
    return (
      <>
      <style>
          {`
            .ant-select-selector{background-image:none}.ant-select-dropdown.css-dev-only-do-not-override-17a39f8.ant-select-dropdown-placement-bottomLeft{display:none}.input-group .ant-select.ant-select-multiple.ant-select-show-arrow.ant-select-show-search .ant-select-selector{border-color:#efefef!important;transition:0;border-left:0;width:100%!important;height:auto!important;min-height:44px;padding:7px 0 7px 7px;border-left:1px solid #000;border-radius:8px!important;overflow:hidden}.input-group .ant-select.ant-select-multiple.ant-select-show-arrow.ant-select-show-search .ant-select-selector:hover{border-left:1px solid #efefef !important}
           .input-group .ant-select.ant-select-multiple.ant-select-show-arrow.ant-select-show-search .ant-select-selector:focus-within:hover{border-left:1px solid #1D8F83 !important}
          `}
        </style>
      <div>
        <ToastContainer />
        <div>
          <div className="d-flex w-100 bg_light">
            <Header />
            <div className="w-100 p-24px">
              <div className="row">
                <div className="col-md-6">
                  <div className="d-flex mb-28px align-items-center">
                    <div className="header_content">
                      <h1 className="nav_heading">My Profile</h1>
                    </div>
                    
                  </div>
                </div>
                <div className="col-md-6">
                  <TopRight page="profile" />
                </div>
              </div>
              <div className="row">
                <div className='col-md-12'>
                <div className="card_content_data d-block h-100">
                    <div className="row">
                      <div className="col-md-2">
                        <div className="tab_links">
                          <h5 className="tab_item">Contact
                          Information</h5>
                        </div>
                      </div>
                      <div className="col-md-10">
                        {/* <div className="tab_content unedited" id=""> */}
                        <div className={(editMode) ? 'tab_content' : 'tab_content unedited'}>
                          <div className="row">
                            <div className="col-md-5">
                              
                            <div className="form_group mb_5px">
                              <label htmlFor="exampleFormControlInput1" className="form-label">Full Name</label>
                              <input type="text" className="form_control" readOnly={!editMode} placeholder="John Legend" aria-label="Username" onChange={(e) => setValues((values) => ({ ...values, name: e.target.value }))} value={values.name} />
                              {/* <div className={(values.name) ? 'input-group flex-nowrap w-100 active' : 'input-group flex-nowrap w-100'}> */}
                              {/* <div className={(values.name) ? 'input-group flex-nowrap w-100' : 'input-group flex-nowrap w-100'}>
                                <span className="input-group-text" id="addon-wrapping">
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke">
                                    <path
                                      d="M15 15.8333C15 13.9916 12.7617 12.4999 10 12.4999C7.23833 12.4999 5 13.9916 5 15.8333M10 9.99992C9.11594 9.99992 8.2681 9.64873 7.64298 9.02361C7.01786 8.39849 6.66667 7.55064 6.66667 6.66659C6.66667 5.78253 7.01786 4.93468 7.64298 4.30956C8.2681 3.68444 9.11594 3.33325 10 3.33325C10.8841 3.33325 11.7319 3.68444 12.357 4.30956C12.9821 4.93468 13.3333 5.78253 13.3333 6.66659C13.3333 7.55064 12.9821 8.39849 12.357 9.02361C11.7319 9.64873 10.8841 9.99992 10 9.99992Z"
                                      strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                <input type="text" className="form_control" readOnly={!editMode} placeholder="John Legend" aria-label="Username" onChange={(e) => setValues((values) => ({ ...values, name: e.target.value }))} value={values.name} />
                              </div> */}
                              <span className="error">{(values.name) ? '' : errors.name}</span>
                            </div>

                            <div className="form_group mb_5px">
                              <label htmlFor="exampleFormControlInput1" className="form-label">Email Address</label>
                              <input type="email" className="form_control" readOnly placeholder="example@gmail.com" aria-label="UserID" onChange={(e) => setValues((values) => ({ ...values, email: e.target.value }))} value={values.email} />
                              {/* <div className={(values.email) ? 'input-group flex-nowrap w-100' : 'input-group flex-nowrap w-100'}>
                                <span className="input-group-text" id="addon-wrapping">
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="fill">
                                    <path
                                      d="M10 17C9.04333 17 8.13917 16.8161 7.2875 16.4484C6.43583 16.0807 5.69197 15.579 5.0559 14.9434C4.4203 14.3078 3.91863 13.5642 3.5509 12.7125C3.18317 11.8608 2.99953 10.9567 3 10C3 9.03167 3.18387 8.12447 3.5516 7.2784C3.91933 6.43233 4.421 5.69173 5.0566 5.0566C5.6922 4.42053 6.4356 3.91887 7.2868 3.5516C8.138 3.18433 9.0424 3.00047 10 3C10.9683 3 11.8755 3.18387 12.7216 3.5516C13.5677 3.91933 14.3083 4.421 14.9434 5.0566C15.5795 5.6922 16.0811 6.43303 16.4484 7.2791C16.8157 8.12517 16.9995 9.03213 17 10V11.015C17 11.7033 16.7639 12.2897 16.2916 12.7741C15.8193 13.2585 15.2388 13.5005 14.55 13.5C14.13 13.5 13.7392 13.4067 13.3775 13.22C13.0158 13.0333 12.7183 12.7883 12.485 12.485C12.17 12.8 11.7995 13.048 11.3734 13.2291C10.9473 13.4102 10.4895 13.5005 10 13.5C9.03167 13.5 8.20613 13.1586 7.5234 12.4759C6.84067 11.7932 6.49953 10.9679 6.5 10C6.5 9.03167 6.84137 8.20613 7.5241 7.5234C8.20683 6.84067 9.03213 6.49953 10 6.5C10.9683 6.5 11.7939 6.84137 12.4766 7.5241C13.1593 8.20683 13.5005 9.03213 13.5 10V11.015C13.5 11.3533 13.605 11.6186 13.815 11.8109C14.025 12.0032 14.27 12.0995 14.55 12.1C14.83 12.1 15.075 12.0036 15.285 11.8109C15.495 11.6182 15.6 11.3529 15.6 11.015V10C15.6 8.47167 15.0486 7.15613 13.9459 6.0534C12.8432 4.95067 11.5279 4.39953 10 4.4C8.47167 4.4 7.15613 4.95137 6.0534 6.0541C4.95067 7.15683 4.39953 8.47213 4.4 10C4.4 11.5283 4.95137 12.8439 6.0541 13.9466C7.15683 15.0493 8.47213 15.6005 10 15.6H12.8C12.9983 15.6 13.1647 15.6672 13.2991 15.8016C13.4335 15.936 13.5005 16.1021 13.5 16.3C13.5 16.4983 13.4328 16.6647 13.2984 16.7991C13.164 16.9335 12.9979 17.0005 12.8 17H10ZM10 12.1C10.5833 12.1 11.0792 11.8958 11.4875 11.4875C11.8958 11.0792 12.1 10.5833 12.1 10C12.1 9.41667 11.8958 8.92083 11.4875 8.5125C11.0792 8.10417 10.5833 7.9 10 7.9C9.41667 7.9 8.92083 8.10417 8.5125 8.5125C8.10417 8.92083 7.9 9.41667 7.9 10C7.9 10.5833 8.10417 11.0792 8.5125 11.4875C8.92083 11.8958 9.41667 12.1 10 12.1Z" />
                                  </svg>
                                </span>
                                <input type="email" className="form_control" readOnly={!editMode} placeholder="example@gmail.com" aria-label="UserID" onChange={(e) => setValues((values) => ({ ...values, email: e.target.value }))} value={values.email} />
                              </div> */}
                              <span className="error">{errors.email}</span>

                            </div>

                            <div className="form_group mb_5px">
                              <label htmlFor="exampleFormControlInput1" className="form-label">Company</label>
                              <input type="text" className="form_control" readOnly={!editMode} placeholder="Facebook" aria-label="Company" onChange={(e) => setValues((values) => ({ ...values, company: e.target.value }))} value={values.company} />
                              {/* <div className={(values.company) ? 'input-group flex-nowrap w-100' : 'input-group flex-nowrap w-100'}>
                                <span className="input-group-text" id="addon-wrapping">
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="stroke">
                                    <path
                                      d="M15.4444 7H4.55556C3.69645 7 3 7.67157 3 8.5V14.5C3 15.3284 3.69645 16 4.55556 16H15.4444C16.3036 16 17 15.3284 17 14.5V8.5C17 7.67157 16.3036 7 15.4444 7Z"
                                      stroke="#BDBDBD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path
                                      d="M8.33333 10.9999L8.50917 11.0883C8.97205 11.3197 9.48247 11.4402 10 11.4402C10.5175 11.4402 11.0279 11.3197 11.4908 11.0883L11.6667 10.9999M7.5 5.99992C7.5 5.55789 7.6756 5.13397 7.98816 4.82141C8.30072 4.50885 8.72464 4.33325 9.16667 4.33325H10.8333C11.2754 4.33325 11.6993 4.50885 12.0118 4.82141C12.3244 5.13397 12.5 5.55789 12.5 5.99992V6.83325H7.5V5.99992Z"
                                      stroke="#BDBDBD" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>
                                <input type="text" className="form_control" readOnly={!editMode} placeholder="Facebook" aria-label="Company" onChange={(e) => setValues((values) => ({ ...values, company: e.target.value }))} value={values.company} />
                              </div> */}
                              <span className="error mb-3">{(values.company) ? '' : errors.company}</span>

                            </div>

                              
                              
                            </div>
                            <div className="col-md-7 text-end d-flex justify-content-end">
                              <div className="d-flex align-items-center justify-content-end h_50px">
                                {
                                  (apiSuccessMessage)
                                  ?
                                  <><p className="text_success">{apiSuccessMessage}</p></>
                                  :
                                  <></>
                                }
                                {
                                  (editMode)
                                  ?
                                  <>
                                    {/* <button type="button" className="btn_primary w_100px" onClick={handleUpdate}>Update</button> */}
                                    <button type="button" className={(updateStart) ? 'btn_primary loading_btn' : 'btn_primary w_100px'} onClick={() => handleUpdate()}>
                                      {
                                        (updateStart) 
                                        ? 
                                        <>
                                          <span className="loader_text hide">Updating... <i className="fa fa-spinner fa-spin ms-1"></i></span>
                                        </> 
                                        : 
                                        <>
                                          <span className="btn_text">Update</span>
                                        </>
                                      }
                                    </button>
                                  </>
                                  :
                                  <>
                                    <button type="button" className="btn_primary w_100px" onClick={handleEdit}>Edit</button>
                                  </>
                                }
                              </div>  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="hr_border" />
                    <div className="row">
                      <div className="col-md-2">
                        <div className="tab_links">
                          <h5 className="tab_item">Partner IDs</h5>
                        </div>
                      </div>
                      <div className="col-md-10">
                        {/* <div className="tab_content unedited"> */}
                        <div className={(editMode) ? 'tab_content' : 'tab_content unedited'}>
                          <div className="row">
                            <div className="col-md-5">
                            <span id="partnerError" style={{display: 'none'}} className="error_head text-start"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" className="me-1">
                        <path fillRule="evenodd" clipRule="evenodd" d="M2.40705 9.71838H9.59855C10.3895 9.71838 10.886 8.86337 10.493 8.17637L6.90005 1.89388C6.50455 1.20238 5.50755 1.20188 5.11155 1.89338L1.51255 8.17588C1.11955 8.86288 1.61555 9.71838 2.40705 9.71838Z" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M6.00098 6.20723V4.65723" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.9975 7.75H6.0025" stroke="#ED0017" strokeLinecap="round" strokeLinejoin="round" />
                      </svg> Any one partner ID is needed</span>

                              <div className="form_group mb-28px">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Google ID</label>
                                <div className="input-group flex-nowrap w-100">
                                  <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    // placeholder="Tags Mode"
                                    // onChange={handleChangeGoogleId}
                                    // defaultValue={values.google_id ? values.google_id : []}
                                    defaultValue={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id}
                                    onChange={handleChangeGoogleId}
                                    disabled={true}
                                  />
                                </div>
                              </div>

                              <div className="form_group mb-28px">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Aniview ID</label>
                                <div className="input-group flex-nowrap w-100">
                                  <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    // placeholder="Tags Mode"
                                    // onChange={handleChangeGoogleId}
                                    // defaultValue={values.aniview_id ? values.aniview_id : []}
                                    defaultValue={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id}
                                    onChange={handleChangeAniviewId}
                                    disabled={true}
                                  />
                                </div>
                              </div>

                              <div className="form_group mb_20px">
                                <label htmlFor="exampleFormControlInput1" className="form-label">AdKernel ID</label>
                                <div className="input-group flex-nowrap w-100">
                                  <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    // placeholder="Tags Mode"
                                    // onChange={handleChangeGoogleId}
                                    // defaultValue={values.adkernel_id}
                                    // defaultValue={values.adkernel_id ? values.adkernel_id : []}
                                    defaultValue={JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id}
                                    onChange={handleChangeAdkernelId}
                                    disabled={true}
                                  />
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  } else {
    window.location.href = "/";
  }

}

export default Profile;